/* eslint-disable @wyz/module/no-relative-import */
import { Col, Flex, Row, Text } from '@wyz/ui';
import * as React from 'react';
import { ALPHABET } from '~/common/helpers';
import { ObjectsByLetter } from '~/connect/types';
import { isNil } from 'lodash-es';
import LetterList from './letter-list';
import AlphabeticalListItem from './item';
function Container({ children }: React.PropsWithChildren) {
  return <Flex className='mt-3'>{children}</Flex>;
}
type ListProps<TItem, TIdentifier extends string | number> = {
  getLetterKey: (letter: string) => string;
  getItemIdentifier: (item: TItem) => TIdentifier;
  getItemLabel: (item: TItem) => string;
  preFilterer?: (item: TItem) => boolean;
  onConfigure?: (item: TItem) => void;
  canConfigure?: boolean;
  canAdd?: boolean;
  canRemove?: boolean;
  onAdd?: (item: TItem) => void;
  isAdded: (item: TItem) => boolean;
  onRemove?: (item: TItem) => void;
  itemsByLetter: ObjectsByLetter<TItem>;
};

function List<TItem, TIdentifier extends string | number>({
  getLetterKey,
  getItemIdentifier,
  getItemLabel,
  preFilterer = () => true,
  onAdd,
  isAdded,
  onRemove,
  itemsByLetter,
  onConfigure,
  canConfigure = false,
  canAdd = true,
  canRemove = true,
}: ListProps<TItem, TIdentifier>) {
  return (
    <div
      className='px-3 overflow-auto w-100'
      style={{
        height: 624,
      }}
    >
      {ALPHABET.filter(
        (letter) =>
          !isNil(itemsByLetter[letter]) && itemsByLetter[letter].length !== 0,
      ).map((letter) => (
        <div key={letter} id={getLetterKey(letter)} className='mb-3'>
          <Text heading='normal' weight='bold'>
            {letter}
          </Text>
          <Row>
            {itemsByLetter[letter]
              ?.filter((item) => preFilterer(item))
              ?.map((item) => {
                const added = isAdded(item);
                return (
                  <Col
                    key={getItemIdentifier(item)}
                    className='my-1 px-1'
                    md={4}
                    xs={12}
                  >
                    <AlphabeticalListItem
                      isAdded={added}
                      label={getItemLabel(item)}
                      value={getItemLabel(item)}
                      item={item}
                      onAdd={onAdd}
                      onRemove={onRemove}
                      onConfigure={onConfigure}
                      canConfigure={canConfigure}
                      canAdd={canAdd}
                      canRemove={canRemove}
                    />
                  </Col>
                );
              })}
          </Row>
        </div>
      ))}
    </div>
  );
}

export default {
  Container: Container,
  Letters: LetterList,
  List: List,
};
